"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversationType = exports.TemplatePrompts = void 0;
var TemplatePrompts;
(function (TemplatePrompts) {
    TemplatePrompts["CREATE_ADDITIONAL_TASKS"] = "CREATE_ADDITIONAL_TASKS";
    TemplatePrompts["CREATE_SUPPLEMENTAL_AIDS"] = "CREATE_SUPPLEMENTAL_AIDS";
    TemplatePrompts["CREATE_LESSON_PLAN"] = "CREATE_LESSON_PLAN";
    TemplatePrompts["CREATE_QUIZ"] = "CREATE_QUIZ";
    TemplatePrompts["CREATE_DIFFERENTIATED_TASKS"] = "CREATE_DIFFERENTIATED_TASKS";
    TemplatePrompts["CREATE_INTRODUCTORY_LESSON"] = "CREATE_INTRODUCTORY_LESSON";
    TemplatePrompts["CREATE_SUMMARY"] = "CREATE_SUMMARY";
    TemplatePrompts["CREATE_LEARNING_POSTER"] = "CREATE_LEARNING_POSTER";
    TemplatePrompts["CREATE_WORKSHEET_FREE_DRAFT"] = "CREATE_WORKSHEET_FREE_DRAFT";
    TemplatePrompts["CREATE_LESSON_PLAN_FREE_DRAFT"] = "CREATE_LESSON_PLAN_FREE_DRAFT";
    TemplatePrompts["CREATE_GROUP_WORK_FREE_DRAFT"] = "CREATE_GROUP_WORK_FREE_DRAFT";
    TemplatePrompts["CREATE_TOPIC_EXPLANATION_FREE_DRAFT"] = "CREATE_TOPIC_EXPLANATION_FREE_DRAFT";
    TemplatePrompts["CREATE_LESSON_SERIES_FREE_DRAFT"] = "CREATE_LESSON_SERIES_FREE_DRAFT";
    TemplatePrompts["CREATE_LEARNING_OBJECTIVE_ASSERTION_FREE_DRAFT"] = "CREATE_LEARNING_OBJECTIVE_ASSERTION_FREE_DRAFT";
    TemplatePrompts["CREATE_ESSAY_FREE_DRAFT"] = "CREATE_ESSAY_FREE_DRAFT";
    TemplatePrompts["CREATE_IMAGE"] = "CREATE_IMAGE";
    TemplatePrompts["CREATE_PODCAST"] = "CREATE_PODCAST";
})(TemplatePrompts || (exports.TemplatePrompts = TemplatePrompts = {}));
var ConversationType;
(function (ConversationType) {
    ConversationType["MIND_ITEM"] = "mindItem";
    ConversationType["FREE_FORM"] = "freeForm";
    ConversationType["UPLOADED_FILE"] = "uploadedFile";
})(ConversationType || (exports.ConversationType = ConversationType = {}));
